const MAX_MB = 5;
const MAX_BYTES = MAX_MB * 1024 * 1024;

// Quality steps tried in order — starts high, steps down only if needed
const QUALITY_STEPS = [0.95, 0.90, 0.85, 0.80, 0.75, 0.65, 0.55];

/**
 * Converts an image File to WebP and compresses it below MAX_MB.
 * Starts at highest quality and steps down only until size fits.
 * Returns a new File with a .webp extension.
 */
export function convertToWebP(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      const canvas = document.createElement('canvas');
      canvas.width  = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext('2d').drawImage(img, 0, 0);

      const webpName = file.name.replace(/\.[^.]+$/, '.webp');

      const tryStep = (stepIndex) => {
        const quality = QUALITY_STEPS[stepIndex] ?? 0.55;

        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error('Image conversion failed. Please try a different file.'));
            return;
          }

          const isLastStep = stepIndex >= QUALITY_STEPS.length - 1;
          if (blob.size <= MAX_BYTES || isLastStep) {
            resolve(new File([blob], webpName, { type: 'image/webp' }));
          } else {
            tryStep(stepIndex + 1);
          }
        }, 'image/webp', quality);
      };

      tryStep(0);
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Could not read the image file. Please try again.'));
    };

    img.src = objectUrl;
  });
}
